import {
  useLazyGetSolutionElectricQuery,
  useLazyGetSolutionHybrideQuery,
} from "store/api";

export enum InstallationType {
  electric = "1",
  hybride = "2",
}
export const useGetSolutionsQuery = () => {
  const [getElectricSolutions, { isFetching: isElectricSolutionsFetching }] =
    useLazyGetSolutionElectricQuery();
  const [getHybrideSolutions, { isFetching: isHybrideSolutionsFetching }] =
    useLazyGetSolutionHybrideQuery();
  const isSolutionsFetching =
    isElectricSolutionsFetching || isHybrideSolutionsFetching;

  return {
    isSolutionsFetching,
    getElectricSolutions,
    getHybrideSolutions,
  };
};
